import React from 'react'
import {Text, Box, AtlasButton} from '@fuegokit/react'
import {AkEditorCloseIcon} from '@fuegokit/fuegoicons-react'
import Toast from '../../../src/components/Toast'
import {
  StyledToast,
  StyledToastViewport,
  StyledToastDescription,
  StyledToastTitle,
  StyledToastClose
} from '../../../src/components/Toast/stories/StoryStyles'

const StyledToastExample = () => {
  const [open, setOpen] = React.useState(false)

  return (
    <Toast.Provider duration={Infinity}>
      <AtlasButton
        onClick={() => {
          setOpen(!open)
        }}
      >
        Save
      </AtlasButton>

      {open && (
        <>
          <StyledToast open={open} onOpenChange={setOpen}>
            <StyledToastTitle></StyledToastTitle>
            <Box sx={{mt: '-18px'}}>
              <StyledToastDescription asChild>
                <Text>Saved!</Text>
              </StyledToastDescription>
            </Box>
            <StyledToastClose onClick={() => setOpen(false)} aria-label="Close">
              <AkEditorCloseIcon aria-hidden />
            </StyledToastClose>
          </StyledToast>
          <StyledToastViewport />
        </>
      )}
    </Toast.Provider>
  )
}
export default StyledToastExample
